import { createColumn, defaultColumns, inputTextField, relationField, editorComponent } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Title',
    field: 'title',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Sort Order',
    field: 'sortOrder',
    type: 'number',
    defaultValue: '0',
    component: inputTextField({ req: true, type: 'number' }),
    description: 'Numeric value that indicates from top to bottom the order of Sponsorship Titles.  Lower numbers on top.'
  }),
  createColumn({
    label: 'Sponsorship Media',
    field: 'sponsorshipMedia',
    // display: 'sponsorship.name',
    ...relationField({
      type: 'many',
      fk: 'sponsorshipTitleId',
      localKey: 'id',
      namespace: 'sponsorshipMedia',
      parentRestraint: false,
      filterIs: 'text-filter',
      requiresParentSave: true,
      // label: 'name',
      // subtitle: '',
      props: { showBrowse: false, showSearch: false }
    })
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    visible: false,
    defaultValue: '',
    // component: inputTextField({ req: false, max: 255, type: 'url' })
    component: editorComponent
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    section: 'Associated Event',
    // description: 'Listing of all users who have access to modify this school'
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'eventId',
      // fk: 'id',
      namespace: 'event',
      filterIs: 'text-filter',
      label: 'name'
    })
  })
].concat(defaultColumns)
